<main *ngIf="company$ | async as company" class="container">
  <div class="content" *ngIf="job$ | async as job">
    <header class="header" [@staggerAnimation]>
      <app-logo
        class="header__logo"
        size="large"
        background="#ffffff"
        color="#8782ff"
        [item]="{
          logoUrl: company.logo,
          companyName: company.name
        }"
      ></app-logo>

      <span itemprop="hiringOrganization" itemscope itemtype="http://schema.org/Organization">
        <a class="header__company-name" [routerLink]="['/']" itemprop="name">{{ company.name }}</a>
      </span>

      <div class="header__helpers">
        <a [routerLink]="['/', 'job', job._id]" class="btn-clean header-button">
          <svg-icon class="header-button__icon" icon="exp-chevron-down" height=".4em" width=".8em"></svg-icon>
          <div i18n>Retour</div>
        </a>
      </div>

      <h1 class="header__title">{{ job.title }}</h1>

      <div class="keywords">
        <span itemprop="employmentType" *ngIf="job.contract" class="keyword">
          <svg-icon class="keyword__icon" icon="exp-briefcase" width="1em"></svg-icon>
          <i18n-contract [model]="job.contract"></i18n-contract>
        </span>

        <span *ngIf="job.duration && job.duration !== durationEnum.Undetermined" class="keyword">
          <svg-icon class="keyword__icon" icon="clock" width="1em"></svg-icon>
          <i18n-contract-duration [model]="job.duration"></i18n-contract-duration>
        </span>

        <app-location [job]="job"></app-location>

        <span *ngIf="job.startDate" class="keyword">
          <svg-icon class="keyword__icon" icon="exp-calendar" width="1em"></svg-icon>
          <span class="header__tag">{{ job.startDate | date }}</span>
        </span>

        <span itemprop="experienceRequirements" *ngIf="job.profileStudyLevel" class="keyword">
          <svg-icon class="keyword__icon" icon="diplome" width="1em"></svg-icon>
          <i18n-study-level [model]="job.profileStudyLevel"></i18n-study-level>
        </span>

        <span itemprop="industry" *ngIf="job.domain" class="keyword">
          <svg-icon class="keyword__icon" icon="exp-price-tag" width="1em"></svg-icon>
          <i18n-domain [model]="job.domain"></i18n-domain>
        </span>

        <app-salary [salaryMin]="job.salaryMin" [salaryMax]="job.salaryMax"> </app-salary>

        <span *ngIf="job.remote" class="keyword">
          <svg-icon class="keyword__icon" icon="exp-laptop" width="1em"></svg-icon>
          <ng-container i18n>Télétravail</ng-container>
        </span>

        <span *ngIf="job.profileExperience" class="keyword">
          <svg-icon class="keyword__icon" icon="exp-joystick" width="1em"></svg-icon>
          <i18n-experience [model]="job.profileExperience"></i18n-experience>
        </span>
      </div>

      <div class="tags" *ngIf="job.skills">
        <span itemprop="skills" class="tags__item" *ngFor="let skill of job.skills; trackBy: trackByLabel">{{
          skill | titlecase
        }}</span>
      </div>
    </header>

    <div class="application">
      <form-application
        id="application-form"
        *ngIf="!send"
        [jobId]="job._id"
        [loading]="loading"
        [error]="error"
        (submitSend)="onSubmit($event)"
      ></form-application>
      <form-application-success *ngIf="send" [jobId]="job._id"></form-application-success>
    </div>
  </div>

  <app-footer location="Application"></app-footer>
</main>
